import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Header, Segment, Form, Input, Button, Modal, Table, Icon } from 'semantic-ui-react';
import { hideLoading, getStickerPricing, getProductOptions, updateStickerPricingTable } from '../actions';
import _ from 'lodash';

class Sticker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            product_name: 'Sticker',
            pricing: []
        }
        document.title = `U-Tech Admin - ${this.state.product_name} ${props.offline ? '(Offline)' : ''}`
        this.props.getStickerPricing(this.props.offline);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.product.pricing !== nextProps.product.pricing) {
            console.log('Pricing changed!');
            console.log(nextProps.product.pricing);
            if (nextProps.product.pricing) {
                let pricing = {
                    ...nextProps.product.pricing,
                    material: {
                        prices: nextProps.product.pricing.material.prices.map((price) => {
                            return {
                                paper_type: price.paper_type,
                                unit_price: price.unit_price.toFixed(2),
                                min_price: price.min_price.toFixed(2)
                            }
                        })
                    },
                    printing: {
                        unit_price: nextProps.product.pricing.printing.unit_price.toFixed(2),
                        min_price: nextProps.product.pricing.printing.min_price.toFixed(2)
                    },
                    plotting: {
                        prices: nextProps.product.pricing.plotting.prices.map((price) => {
                            return {
                                quantity_from: price.quantity_from.toFixed(0),
                                unit_price: price.unit_price.toFixed(2)
                            }
                        })
                    }
                }
                pricing.material.new = { paper_type: '', unit_price: '', min_price: '' };
                pricing.plotting.new = { quantity_from: '', unit_price: '' };
                this.setState({ pricing: pricing });
                this.props.hideLoading();
            }
        }
    }

    handleEditClicked(id, e) {
        let newArr = this.state.pricing;

        switch (id) {
            case 'material':
                newArr[id].edit = !newArr[id].edit;
                if (!newArr[id].edit) {
                    newArr[id].prices = this.props.product.pricing.material.prices.map((price) => {
                        return {
                            paper_type: price.paper_type,
                            unit_price: price.unit_price.toFixed(2),
                            min_price: price.min_price.toFixed(2)
                        }
                    });
                    newArr[id].add = false;
                    newArr[id].new = { paper_type: "", unit_price: "", min_price: "" };
                }
                this.setState({ pricing: newArr });
                break;

            case 'printing':
                newArr[id].edit = !newArr[id].edit;
                if (!newArr[id].edit) {
                    newArr[id] = {
                        unit_price: this.props.product.pricing.printing.unit_price.toFixed(2),
                        min_price: this.props.product.pricing.printing.min_price.toFixed(2)
                    }
                }
                this.setState({ pricing: newArr });
                break;

            case 'plotting':
                newArr[id].edit = !newArr[id].edit;
                if (!newArr[id].edit) {
                    newArr[id].prices = this.props.product.pricing.plotting.prices.map((price) => {
                        return {
                            quantity_from: price.quantity_from.toFixed(0),
                            unit_price: price.unit_price.toFixed(2)
                        }
                    });
                    newArr[id].add = false;
                    newArr[id].new = { quantity_from: "", unit_price: "" };
                }
                this.setState({ pricing: newArr });
                break;

            case 'misc':
                newArr[id].edit = !newArr[id].edit;
                if (!newArr[id].edit) {
                    newArr[id] = {
                        duration: newArr.misc.duration.toFixed(0),
                    }
                }
                this.setState({ pricing: newArr });
                break;

            default:
                break;
        }
    }

    handleRowDelete(id, row, e) {
        let newArr = this.state.pricing;

        switch (id) {
            case 'material':
            case 'plotting':
                if (newArr[id].edit) {
                    newArr[id].prices.splice(row, 1);
                    this.setState({ pricing: newArr });
                }
                break;

            default:
                break;
        }
    }

    handleGroupInputChange(id, e) {
        let newArr = this.state.pricing;

        switch (id) {
            case 'printing':
                if (newArr[id].edit) {
                    newArr[id][e.target.name] = e.target.value;
                    this.setState({ pricing: newArr });
                }
                break;

            case 'misc':
                if (newArr[id].edit) {
                    newArr.duration = e.target.value;
                    this.setState({ pricing: newArr });
                }
                break;

            default:
                break;
        }

    }

    handleTableInputChange(id, row, e) {
        let newArr = this.state.pricing;

        switch (id) {
            case 'material':
                if (newArr[id].edit) {
                    if (row === -1) {
                        newArr[id].new[e.target.name] = e.target.value;
                    } else {
                        newArr[id].prices[row][e.target.name] = e.target.value;
                    }
                    this.setState({ pricing: newArr });
                }
                break;

            case 'plotting':
                if (newArr[id].edit) {
                    if (row === -1) {
                        newArr[id].new[e.target.name] = e.target.value;
                    } else {
                        newArr[id].prices[row][e.target.name] = e.target.value;
                    }
                    this.setState({ pricing: newArr });
                }
                break;

            default:
                break;
        }
    }

    handleResetRow(id, e) {
        let newArr = this.state.pricing;

        switch (id) {
            case 'material':
                if (newArr[id].edit) {
                    newArr[id].new['paper_type'] = '';
                    newArr[id].new['unit_price'] = '';
                    newArr[id].new['min_price'] = '';
                    newArr[id].error = false;
                    this.setState({ pricing: newArr });
                }
                break;

            case 'plotting':
                if (newArr[id].edit) {
                    newArr[id].new['quantity_from'] = '';
                    newArr[id].new['unit_price'] = '';
                    newArr[id].error = false;
                    this.setState({ pricing: newArr });
                }
                break;

            default:
                break;
        }
    }

    handleAddRow(id, e) {
        let newArr = this.state.pricing;
        console.log(id);
        console.log(newArr[id]);
        switch (id) {
            case 'material':
                if (newArr[id].add) {
                    if ((newArr[id].new['paper_type'].length > 0) &&
                        (newArr[id].new['unit_price'].length > 0) &&
                        (newArr[id].new['min_price'].length > 0)) {

                        let newObj = {
                            paper_type: newArr[id].new['paper_type'].trim(),
                            unit_price: newArr[id].new['unit_price'].trim(),
                            min_price: newArr[id].new['min_price'].trim()
                        };

                        console.log(newObj);
                        if (newArr[id].prices.findIndex(el => ((el.paper_type === newObj.paper_type))) === -1) {
                            newArr[id].prices.push(newObj);
                            newArr[id].new['paper_type'] = '';
                            newArr[id].new['unit_price'] = '';
                            newArr[id].new['min_price'] = '';
                            newArr[id].prices = _.orderBy(newArr[id].prices, ['paper_type'], ['asc']);
                        } else {
                            newArr[id].error = true;
                        }
                    } else {
                        newArr[id].error = true;
                    }
                    this.setState({ pricing: newArr });
                } else {
                    newArr[id].new['paper_type'] = '';
                    newArr[id].new['unit_price'] = '';
                    newArr[id].new['min_price'] = '';
                    newArr[id].add = true;
                    this.setState({ pricing: newArr });
                }
                break;

            case 'plotting':
                if (newArr[id].add) {
                    if ((newArr[id].new['quantity_from'].length > 0) &&
                        (newArr[id].new['unit_price'].length > 0)) {

                        let newObj = {
                            quantity_from: newArr[id].new['quantity_from'].trim(),
                            unit_price: newArr[id].new['unit_price'].trim()
                        };

                        if (newArr[id].prices.findIndex(el => ((el.quantity_from === newObj.quantity_from))) === -1) {
                            newArr[id].prices.push(newObj);
                            newArr[id].new['quantity_from'] = '';
                            newArr[id].new['unit_price'] = '';
                            console.log(newArr[id].prices);
                            newArr[id].prices = newArr[id].prices.sort((a, b) => {return a.quantity_from - b.quantity_from})
                            // newArr[id].prices = _.orderBy(newArr[id].prices, ['quantity_from'], ['asc']);
                        } else {
                            newArr[id].error = true;
                        }
                    } else {
                        newArr[id].error = true;
                    }
                    this.setState({ pricing: newArr });
                } else {
                    newArr[id].new['quantity_from'] = '';
                    newArr[id].new['unit_price'] = '';
                    newArr[id].add = true;
                    this.setState({ pricing: newArr });
                }
                break;


            default:
                break;
        }
    }

    handleSaveClicked(id, e) {
        let newArr = this.state.pricing;

        switch (id) {
            case 'material':
                if (newArr[id].edit) {
                    if ((newArr[id].new['paper_type'].length > 0) && (newArr[id].new['unit_price'].length > 0) && (newArr[id].new['min_price'].length > 0)) {
                        let newObj = {
                            paper_type: newArr[id].new['paper_type'].trim(),
                            unit_price: newArr[id].new['unit_price'].trim(),
                            min_price: newArr[id].new['min_price'].trim()
                        };
                        if (newArr[id].prices.findIndex(el => ((el.paper_type === newObj.paper_type))) === -1) {
                            newArr[id].prices.push(newObj);
                            newArr[id].new['paper_type'] = '';
                            newArr[id].new['unit_price'] = '';
                            newArr[id].new['min_price'] = '';
                            newArr[id].error = false;
                            newArr[id].edit = false;
                            newArr[id].add = false;
                            // newArr[id].prices = _.orderBy(newArr[id].prices, ['paper_type'], ['asc']);
                            newArr[id].prices.forEach((price, index) => {
                                newArr[id].prices[index].unit_price = (newArr[id].prices[index].unit_price) ? parseFloat(newArr[id].prices[index].unit_price) : 0.0;
                                newArr[id].prices[index].min_price = (newArr[id].prices[index].min_price) ? parseFloat(newArr[id].prices[index].min_price) : 0.0;
                            });
                            this.props.updateStickerPricingTable({ cat: id, updates: { prices: newArr[id].prices } }, this.props.offline);
                        } else {
                            newArr[id].error = true;
                            this.setState({ pricing: newArr });
                        }
                    } else {
                        newArr[id].edit = false;
                        newArr[id].add = false;
                        newArr[id].error = false;
                        // newArr[id].prices = _.orderBy(newArr[id].prices, ['paper_type'], ['asc']);
                        newArr[id].prices.forEach((price, index) => {
                            newArr[id].prices[index].unit_price = (newArr[id].prices[index].unit_price) ? parseFloat(newArr[id].prices[index].unit_price) : 0.0;
                            newArr[id].prices[index].min_price = (newArr[id].prices[index].min_price) ? parseFloat(newArr[id].prices[index].min_price) : 0.0;
                        });
                        this.props.updateStickerPricingTable({ cat: id, updates: { prices: newArr[id].prices } }, this.props.offline);
                    }
                }
                break;

            case 'printing':
                if (newArr[id].edit) {
                    console.log(newArr[id]);
                    if ((newArr[id].unit_price.length > 0) && (newArr[id].min_price.length > 0)) {
                        newArr[id].unit_price = parseFloat(newArr[id].unit_price);
                        newArr[id].min_price = parseFloat(newArr[id].min_price);
                        newArr[id].edit = false;
                        this.props.updateStickerPricingTable({ cat: id, updates: { unit_price: newArr[id].unit_price, min_price: newArr[id].min_price } }, this.props.offline);
                    } else {
                        newArr[id].error = true;
                        this.setState({ pricing: newArr });
                    }
                }
                break;

            case 'plotting':
                if (newArr[id].edit) {
                    if ((newArr[id].new['quantity_from']) && (newArr[id].new['unit_price'])) {
                        let newObj = {
                            quantity_from: parseInt(newArr[id].new['quantity_from']),
                            unit_price: parseFloat(newArr[id].new['unit_price'])
                        };
                        if (newArr[id].prices.findIndex(el => ((el.quantity_from === newObj.quantity_from))) === -1) {
                            newArr[id].prices.push(newObj);
                            newArr[id].new['quantity_from'] = '';
                            newArr[id].new['unit_price'] = '';
                            newArr[id].error = false;
                            newArr[id].edit = false;
                            newArr[id].add = false;
                            newArr[id].prices.forEach((price, index) => {
                                newArr[id].prices[index].quantity_from = (newArr[id].prices[index].quantity_from) ? parseFloat(newArr[id].prices[index].quantity_from) : 0.0;
                                newArr[id].prices[index].unit_price = (newArr[id].prices[index].unit_price) ? parseFloat(newArr[id].prices[index].unit_price) : 0.0;
                            });
                            newArr[id].prices = _.orderBy(newArr[id].prices, ['quantity_from'], ['asc']);
                            this.props.updateStickerPricingTable({ cat: id, updates: { prices: newArr[id].prices } }, this.props.offline);
                        } else {
                            newArr[id].error = true;
                            this.setState({ pricing: newArr });
                        }
                    } else {
                        newArr[id].edit = false;
                        newArr[id].add = false;
                        newArr[id].error = false;
                        newArr[id].prices.forEach((price, index) => {
                            newArr[id].prices[index].quantity_from = (newArr[id].prices[index].quantity_from) ? parseFloat(newArr[id].prices[index].quantity_from) : 0.0;
                            newArr[id].prices[index].unit_price = (newArr[id].prices[index].unit_price) ? parseFloat(newArr[id].prices[index].unit_price) : 0.0;
                        });
                        newArr[id].prices = _.orderBy(newArr[id].prices, ['quantity_from'], ['asc']);
                        this.props.updateStickerPricingTable({ cat: id, updates: { prices: newArr[id].prices } }, this.props.offline);
                    }
                }
                break;

            case 'misc':
                if (newArr[id].edit) {
                    if (newArr.duration > 0) {
                        newArr[id].edit = false;
                        newArr[id].error = false;
                        this.props.updateStickerPricingTable({ cat: 'duration', updates: parseInt(newArr.duration) }, this.props.offline);
                    } else {
                        newArr[id].error = true;
                        this.setState({ error: newArr[id].error })
                    }
                }
                break;

            default:
                break;
        }
    }

    renderMaterial() {
        const { material } = this.state.pricing;

        return (
            <Segment>
                <Header as="h3" textAlign="center">Material</Header>
                <Form>
                    <Table compact celled>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Material</Table.HeaderCell>
                                <Table.HeaderCell>Unit Price (RM)</Table.HeaderCell>
                                <Table.HeaderCell>Minmum Price (RM)</Table.HeaderCell>
                                <Table.HeaderCell collapsing><Icon name="edit" onClick={this.handleEditClicked.bind(this, 'material')} /></Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {material.prices &&
                                material.prices.map((price, row) => (
                                    <Table.Row key={row}>
                                        <Table.Cell>
                                            <Form.Field control="input" type="text" name="paper_type" value={price.paper_type} disabled={!material.edit} onChange={this.handleTableInputChange.bind(this, 'material', row)} />
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Form.Field control="input" type="number" step="0.01" name="unit_price" defaultValue={price.unit_price} value={price.unit_price} disabled={!material.edit} onChange={this.handleTableInputChange.bind(this, 'material', row)} />
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Form.Field control="input" type="number" step="0.01" name="min_price" defaultValue={price.min_price} value={price.min_price} disabled={!material.edit} onChange={this.handleTableInputChange.bind(this, 'material', row)} />
                                        </Table.Cell>
                                        <Table.Cell collapsing>
                                            <Icon name={(material.edit) ? 'delete' : ''} color="red" onClick={this.handleRowDelete.bind(this, 'material', row)} />
                                        </Table.Cell>
                                    </Table.Row>
                                ))
                            }
                            {(material.add) &&
                                <Table.Row warning={!material.error} error={material.error}>
                                    <Table.Cell>
                                        <Form.Field control="input" type="text" name="paper_type" value={material.new.paper_type} onChange={this.handleTableInputChange.bind(this, 'material', -1)} />
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Form.Field control="input" type="number" step="0.01" name="unit_price" value={material.new.unit_price} onChange={this.handleTableInputChange.bind(this, 'material', -1)} />
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Form.Field control="input" type="number" step="0.01" name="min_price" value={material.new.min_price} onChange={this.handleTableInputChange.bind(this, 'material', -1)} />
                                    </Table.Cell>
                                    <Table.Cell collapsing>
                                        <Icon name="undo" onClick={this.handleResetRow.bind(this, 'material')} />
                                    </Table.Cell>
                                </Table.Row>
                            }
                        </Table.Body>
                        {
                            (material.edit) &&
                            <Table.Footer fullWidth>
                                <Table.Row>
                                    <Table.HeaderCell colSpan="4">
                                        <Fragment>
                                            <Button floated="right" icon labelPosition="left" primary size="small" onClick={this.handleAddRow.bind(this, 'material')}>
                                                <Icon name="add" />Add
                                            </Button>
                                            <Button floated="right" icon labelPosition="left" primary size="small" onClick={this.handleSaveClicked.bind(this, 'material')}>
                                                <Icon name="save" />Save
                                            </Button>
                                        </Fragment>
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Footer>
                        }
                    </Table>
                </Form>
            </Segment>
        )
    }

    renderPrinting() {
        const { printing } = this.state.pricing;

        return (
            <Segment>
                <Header as="h3" textAlign="center">Printing (4 Colour Single Side)</Header>
                <Form>
                    <Table compact celled selectable={false}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Unit Price (RM)</Table.HeaderCell>
                                <Table.HeaderCell>Minimum Price (RM)</Table.HeaderCell>
                                <Table.HeaderCell collapsing><Icon name="edit" onClick={this.handleEditClicked.bind(this, 'printing')} /></Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row error={printing.error}>
                                <Table.Cell>
                                    <Form.Field control="input" type="number" step="0.01" name="unit_price" value={printing.unit_price} disabled={!printing.edit} onChange={this.handleGroupInputChange.bind(this, 'printing')} />
                                </Table.Cell>
                                <Table.Cell>
                                    <Form.Field control="input" type="number" step="0.01" name="min_price" value={printing.min_price} disabled={!printing.edit} onChange={this.handleGroupInputChange.bind(this, 'printing')} />
                                </Table.Cell>
                                <Table.Cell collapsing>
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                        {printing.edit &&
                            <Table.Footer fullWidth>
                                <Table.Row>
                                    <Table.HeaderCell colSpan="4">
                                        <Button floated="right" icon labelPosition="left" primary size="small" disabled={!printing.edit} onClick={this.handleSaveClicked.bind(this, 'printing')}>
                                            <Icon name="save" />Save
                                        </Button>
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Footer>
                        }
                    </Table>
                </Form>
            </Segment>
        )
    }

    renderPlotting() {
        const { plotting } = this.state.pricing;

        return (
            <Segment>
                <Header as="h3" textAlign="center">Plotting</Header>
                <Form>
                    <Table compact celled>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Quantity (pcs)</Table.HeaderCell>
                                <Table.HeaderCell>Unit Price (RM)</Table.HeaderCell>
                                <Table.HeaderCell collapsing> <Icon name="edit" onClick={this.handleEditClicked.bind(this, 'plotting')} /></Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {plotting.prices &&
                                plotting.prices.map((price, row) => (
                                    <Table.Row key={row}>
                                        <Table.Cell>
                                            <Form.Field control="input" type="number" step="1" name="quantity_from" defaultValue={price.quantity_from} value={price.quantity_from} disabled={!plotting.edit} onChange={this.handleTableInputChange.bind(this, 'plotting', row)} />
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Form.Field control="input" type="number" step="0.01" name="unit_price" defaultValue={price.unit_price} value={price.unit_price} disabled={!plotting.edit} onChange={this.handleTableInputChange.bind(this, 'plotting', row)} />
                                        </Table.Cell>
                                        <Table.Cell collapsing>
                                            <Icon name={(plotting.edit) ? 'delete' : ''} color="red" onClick={this.handleRowDelete.bind(this, 'plotting', row)} />
                                        </Table.Cell>
                                    </Table.Row>
                                ))
                            }
                            {(plotting.add) &&
                                <Table.Row warning={!plotting.error} error={plotting.error}>
                                    <Table.Cell>
                                        <Form.Field control="input" type="number" step="1" name="quantity_from" value={plotting.new.quantity_from} onChange={this.handleTableInputChange.bind(this, 'plotting', -1)} />
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Form.Field control="input" type="number" step="0.01" name="unit_price" value={plotting.new.unit_price} onChange={this.handleTableInputChange.bind(this, 'plotting', -1)} />
                                    </Table.Cell>
                                    <Table.Cell collapsing>
                                        <Icon name="undo" onClick={this.handleResetRow.bind(this, 'plotting')} />
                                    </Table.Cell>
                                </Table.Row>
                            }
                        </Table.Body>
                        {
                            (plotting.edit) &&
                            <Table.Footer fullWidth>
                                <Table.Row>
                                    <Table.HeaderCell colSpan="3">
                                        <Fragment>
                                            <Button floated="right" icon labelPosition="left" primary size="small" onClick={this.handleAddRow.bind(this, 'plotting')}>
                                                <Icon name="add" />Add
                                            </Button>
                                            <Button floated="right" icon labelPosition="left" primary size="small" onClick={this.handleSaveClicked.bind(this, 'plotting')}>
                                                <Icon name="save" />Save
                                            </Button>
                                        </Fragment>
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Footer>
                        }
                    </Table>
                </Form>
            </Segment>
        )
    }

    renderMiscellaneous() {
        const { misc, duration } = this.state.pricing;

        return (
            <Segment>
                <Header as="h3" textAlign="center">Miscellaneous</Header>
                <Table compact celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell></Table.HeaderCell>
                            <Table.HeaderCell collapsing> <Icon name="edit" onClick={this.handleEditClicked.bind(this, 'misc')} /></Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Footer fullWidth>
                        <Table.Row error={misc.error}>
                            <Table.Cell colSpan="2">
                                <Form.Field inline>
                                    <label >Duration</label>
                                    <Input style={{ padding: '0px 10px' }} type="number" step="1" name="duration" value={duration} disabled={!misc.edit} onChange={this.handleGroupInputChange.bind(this, 'misc')} />
                                </Form.Field>
                            </Table.Cell>
                        </Table.Row>
                        {
                            (misc.edit) &&
                            <Table.Row>
                                <Table.HeaderCell colSpan="2">
                                    <Fragment>
                                        <Button floated="right" icon labelPosition="left" primary size="small" onClick={this.handleSaveClicked.bind(this, 'misc')}>
                                            <Icon name="save" />Save
                                            </Button>
                                    </Fragment>
                                </Table.HeaderCell>
                            </Table.Row>
                        }
                    </Table.Footer>
                </Table>
            </Segment>
        )
    }


    render() {
        const { pricing } = this.state;

        return (
            <Container>
                <Header as="h2">Sticker</Header>
                <Segment.Group raised>
                    {(pricing.material) &&
                        this.renderMaterial()
                    }
                </Segment.Group>
                <Segment.Group raised>
                    {(pricing.printing) &&
                        this.renderPrinting()
                    }
                </Segment.Group>
                <Segment.Group raised>
                    {(pricing.plotting) &&
                        this.renderPlotting()
                    }
                </Segment.Group>
                <Segment.Group raised>
                    {(pricing.misc) &&
                        this.renderMiscellaneous()
                    }
                </Segment.Group>
            </Container>
        )
    }
}

const mapStateToProps = ({ product }) => {
    return { product };
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        hideLoading: hideLoading,
        getStickerPricing: getStickerPricing,
        getProductOptions: getProductOptions,
        updateStickerPricingTable: updateStickerPricingTable
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Sticker);